// extracted by mini-css-extract-plugin
export default {"container":"parallel-phone-layout_container__sFg0+","phone-container":"parallel-phone-layout_phone-container__AHxNm","cancel":"parallel-phone-layout_cancel__zdIPJ"};